module.exports = __webpack_public_path__ + "img/Logo_MetroRio2.05ac36e8.png";